import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HotkeyComponent } from './hotkey.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HotkeyComponent],
  exports: [HotkeyComponent],
})
export class HotkeyModule {}
export { HotkeyComponent, HotkeyConfigs } from './hotkey.component';
